/**
 * Returns true when a JWT exists and its exp claim is still in the future.
 * @param {string} token
 * @return {boolean}
 */
export function isJwtTokenValid(token) {
  if (!token || typeof token !== 'string') {
    return false;
  }
  try {
    const payloadSegment = token.split('.')[1];
    if (!payloadSegment) {
      return false;
    }
    const payload = JSON.parse(atob(payloadSegment));
    if (!payload.exp) {
      return false;
    }
    return payload.exp * 1000 > Date.now();
  } catch (e) {
    return false;
  }
}

export function hasValidJwtToken(userDetail) {
  return isJwtTokenValid(userDetail && userDetail.jwtToken);
}
